import { Guid } from "@/types"

export interface IGetProductModelArticleDto {
    id: string
    description: string
    thumbnailUri?: string
}

export default class ProductModelArticle {
    id: Guid
    description: string
    thumbnailUri?: string

    constructor(dto: IGetProductModelArticleDto) {
        this.id = dto.id
        this.description = dto.description
        this.thumbnailUri = dto.thumbnailUri
    }
}
